<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .text {
    @include mixins.body2();
    @include colors.color(textBlack);
  }

  .link-text {
    text-decoration: underline;
  }
</style>

<script>
  import BannerNotification from "@sourcewhale/shared/svelte-design-system/components/atoms/BannerNotification.svelte";
  import IconButton from "@sourcewhale/shared/svelte-design-system/components/atoms/IconButton.svelte";
  import Link from "@sourcewhale/shared/svelte-design-system/components/atoms/Link.svelte";
  import { showSearchSignpostBanner } from "./stores";

  const removeBanner = () => {
    showSearchSignpostBanner.set(false);
  };
</script>

{#if $showSearchSignpostBanner}
  <BannerNotification message="ai" style="margin-top: 16px;">
    <span class="text">
      Effortlessly search your CRM and add contacts straight into SourceWhale
    </span>
    <Link href="/search">
      <span class="link-text">Open Search AI</span>
    </Link>
    <IconButton
      style="margin-left: auto; margin-right: -8px;"
      icon="fa-xmark"
      size="small"
      onclick={removeBanner}
    />
  </BannerNotification>
{/if}
